import "../App.css";

const Message = ({ data, handleClick }) => {
  const { type, message, desc } = data;

  return (
    <div className={`message ${type === "success" ? "success" : "error"}`}>
      <div className="close" onClick={()=>handleClick(false)}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.66829 23.6673L0.334961 21.334L9.66829 12.0007L0.334961 2.66732L2.66829 0.333984L12.0016 9.66732L21.335 0.333984L23.6683 2.66732L14.335 12.0007L23.6683 21.334L21.335 23.6673L12.0016 14.334L2.66829 23.6673Z"
            fill="#1C1B1F"
            fillOpacity="0.5"
          ></path>
        </svg>
      </div>
      <img src={type === "error" ? "/remove.svg" : "/check.svg"} alt="check" height={50} width={50} />
      <div className="message-title">
        {message || "Your form has been submitted."}
      </div>
      <div className="message-desc">
        {desc && <div>{desc}</div>}
      </div>
    </div>
  );
};

export default Message;
